import React, { useState } from "react";
import classNames from "classnames";

const SwitchToggle = ({ style, ...props }) => {
  const checked = props.active;

  let clickFunc;

  const toggle = () => {
    if (props.onChange) {
      props.onChange();
    }
  };

  if (props.onClick) {
    clickFunc = props.onClick;
  } else {
    clickFunc = toggle;
  }

  let yesLabel = "yes";
  let noLabel = "no";

  if (props.Text && props.Text.length === 2) {
    yesLabel = props.Text[0];
    noLabel = props.Text[1];
  }

  return (
    <div style={{ display: "flex", alignItems: "center", ...style }}>
      <div
        className={"toggle-switch" + (props.Small ? " small-switch" : "")}
        onClick={clickFunc}
        style={{ flexShrink: 0 }}
      >
        <input
          type="checkbox"
          className="toggle-switch-checkbox"
          checked={checked}
          defaultChecked={props.defaultChecked}
          onChange={toggle}
          disabled={props.disabled}
        />
        <label className="toggle-switch-label">
          <span
            className={
              props.disabled
                ? "toggle-switch-inner toggle-switch-disabled"
                : "toggle-switch-inner"
            }
            data-yes={yesLabel}
            data-no={noLabel}
          />
          <span
            className={
              props.disabled
                ? "toggle-switch-switch toggle-switch-disabled"
                : "toggle-switch-switch"
            }
          />
        </label>
      </div>
      <div style={{ marginLeft: "12px", flex: 1 }}>{props.children}</div>
    </div>
  );
};


export default SwitchToggle;
